import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "pretty-checkbox-react";

function FuseCheckBox(props) {
  const { id, value, disabled, onChange } = props;

  const getValue = () => {
    if (value === true || value === "true") return true;
    else return false;
  };

  return (
    <Checkbox
      key={id}
      className="fuse-checkbox m-1"
      checked={getValue()}
      disabled={disabled === true}
      onChange={(e) => {
        onChange(e?.target?.checked === true);
      }}
    />
  );
}

FuseCheckBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool
};

export default FuseCheckBox;
